
  $(function() {
    $('.article-section').wrapAll('<div class= "article-wrap">');
    $('.article-content').wrapAll('<div class= "article-content-wrap">');
  });

  $(function(){
    $('a[href^=#]').click(function() {
    var speed = 500; // スクロール速度(ミリ秒)
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $('html').animate({scrollTop:position}, speed, 'swing');
    return false;
    });
  }); 